'use client'

import { useEffect } from 'react'
import { trackPageView } from '@/utilities/gtag'

/**
 * P0-2 (doc 046): explicit page_view for 404s so GA4 doesn't end up with
 * `(not set)` landing pages for the ~36 organic sessions/month that hit
 * broken URLs. We don't want the tracker to dedupe against an existing
 * page_view, so this just sends the event with the actual 404 URL.
 *
 * P2-7 (doc 046): same bot-UA guard as `PageViewTracker` so 404 spam
 * from crawlers doesn't pollute the metrics.
 */
const BOT_UA_PATTERN =
  /bot|crawl|spider|slurp|bingpreview|facebookexternalhit|WhatsApp\//i
// P0-2b (doc 047): narrowed to drop `whatsapp|telegram|discord` — those substrings
// match real in-app browsers (WhatsApp/2.24, Telegram/, Discord/) and were
// silently skipping trackPageView() for human visitors, leaving them with no
// page_view at all and GA4 recording `(not set)` as the landing page.
// The original P2-7 list is preserved in src/utilities/gtag.ts history if
// anyone needs to re-enable broader filtering later.

export function NotFoundPageView() {
  useEffect(() => {
    if (typeof navigator !== 'undefined' && BOT_UA_PATTERN.test(navigator.userAgent)) {
      return
    }
    trackPageView()
  }, [])
  return null
}
